import {createSelector} from 'reselect';
import authSelectors from 'src/modules/auth/authSelectors';
import PermissionChecker from 'src/modules/auth/permissionChecker';
import {matchPermissionForUi} from 'src/security/customRoleScopedPermissionUi';
import Permissions from 'src/security/permissions';

const selectPermissionToRead = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser], (currentTenant, currentUser) => new PermissionChecker(currentTenant, currentUser).match(Permissions.values.tareaRead),
);

const selectPermissionToEdit = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser], (currentTenant, currentUser) => new PermissionChecker(currentTenant, currentUser).match(Permissions.values.tareaEdit),
);

const selectPermissionToEditClosed = createSelector(
  [
    authSelectors.selectCurrentTenant,
    authSelectors.selectCurrentUser,
    authSelectors.selectTenantAccessContext,
  ],
  (currentTenant, currentUser, tenantAccessContext) =>
    new PermissionChecker(currentTenant, currentUser, tenantAccessContext).match(
      Permissions.values.tareaEditClosed,
    ),
);

const selectPermissionToCreate = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser],
  (currentTenant, currentUser) =>
    matchPermissionForUi(
      new PermissionChecker(currentTenant, currentUser),
      Permissions.values.tareaCreate,
    ),
);

const selectPermissionToImport = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser], (currentTenant, currentUser) => new PermissionChecker(currentTenant, currentUser).match(Permissions.values.tareaImport),
);

const selectPermissionToDestroy = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser], (currentTenant, currentUser) => new PermissionChecker(currentTenant, currentUser).match(Permissions.values.tareaDestroy),
);

const selectPermissionToReassign = createSelector(
  [
    authSelectors.selectCurrentTenant,
    authSelectors.selectCurrentUser,
    authSelectors.selectTenantAccessContext,
  ],
  (currentTenant, currentUser, tenantAccessContext) =>
    new PermissionChecker(currentTenant, currentUser, tenantAccessContext).match(
      Permissions.values.tareaReassign,
    ),
);

const selectPermissionToKanban = createSelector(
  [authSelectors.selectCurrentTenant, authSelectors.selectCurrentUser], (currentTenant, currentUser) => new PermissionChecker(currentTenant, currentUser).match(Permissions.values.tareaKanban),
);

const tareaSelectors = {
  selectPermissionToRead,
  selectPermissionToEdit,
  selectPermissionToEditClosed,
  selectPermissionToCreate,
  selectPermissionToDestroy,
  selectPermissionToImport,
  selectPermissionToReassign,
  selectPermissionToKanban,
};

export default tareaSelectors;
